export const absCenterStyles = {
  position: 'absolute',
  w: '100%',
  left: 0,
  right: 0,
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 100,
}

export const labelBottom = -16

export const maxValue = 100
